import React from "react";
import { Route } from "react-router-dom";
import AuthGuard from "../pages/SHARED/Utilities/AuthGuard";

// Bond creation
import VermostOutsiderStartBondRequest from "../pages/SHARED/Bond Creation/StartRequest";
import VermostProbateBondRequestForm from "../pages/SHARED/Bond Creation/ProbateBond";
import VermostGuardianshipBondRequestForm from "../pages/SHARED/Bond Creation/GuardianshipBond";
import VermostVABondRequestForm from "../pages/SHARED/Bond Creation/VABond";
import VermostTrusteeBondRequestForm from "../pages/SHARED/Bond Creation/TrusteeBond";
import VermostBlanketBondRequestForm from "../pages/SHARED/Bond Creation/BlanketBond";

// Bond retrieval
import VermostProbateBondRetrieveForm from "../pages/SHARED/Bond Retrieval/ProbateBondRetrieve";
import VermostGuardianshipBondRetrieveForm from "../pages/SHARED/Bond Retrieval/GuardianshipBondRetrieve";
import VermostVABondRetrieveForm from "../pages/SHARED/Bond Retrieval/VABondRetrieve";
import VermostTrusteeBondRetrieveForm from "../pages/SHARED/Bond Retrieval/TrusteeBondRetrieve";
import VermostBlanketBondRetrieveForm from "../pages/SHARED/Bond Retrieval/BlanketBondRetrieve";

// Historic bond creation
import VermostOutsiderStartBondRequestHistoric from "../pages/SHARED/Bond Creation Historic/StartRequest";
import ProbateBondCreateHistoric from "../pages/SHARED/Bond Creation Historic/ProbateBondCreateHistoric";
import GuardianshipBondCreateHistoric from "../pages/SHARED/Bond Creation Historic/GuardianshipBondCreateHistoric";
import TrusteeBondCreateHistoric from "../pages/SHARED/Bond Creation Historic/TrusteeBondCreateHistoric";
import BlanketBondCreateHistoric from "../pages/SHARED/Bond Creation Historic/BlanketBondCreateHistoric";
import VABondCreateHistoric from "../pages/SHARED/Bond Creation Historic/VABondCreateHistoric";

// Bond operations
import ApproveBondsPage from "../pages/ApproveBondsPage";
import BondArchives from "../pages/BondArchives";
import ApproveBondsTeamMemberPage from "../pages/ApproveBondsTeamMember";
import PremiumCalculator from "../pages/SHARED/PremiumCalculator";

// Rider pages
import ProbateRider from "../pages/Internal User/Admin User/ProbateRider";
import GuardianshipRider from "../pages/Internal User/Admin User/GuardianshipRider";
import TrusteeRider from "../pages/Internal User/Admin User/TrusteeRider";
import VABondRider from "../pages/Internal User/Admin User/VABondRider";

// Internal user pages
import SimpleUserHome from "../pages/Internal User/Internal User/Home";
import SimpleUserAccountManagement from "../pages/Internal User/Internal User/AccountManagement";
import SimpleUserDataManagement from "../pages/Internal User/Internal User/DataManagement";
import SimpleUserSystemManagement from "../pages/Internal User/Internal User/SystemManagement";

// Management pages
import ProfessionalGuardianList from "../pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianList";
import ProfessionalGuardianView from "../pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianView";
import CreateProfessionalGuardian from "../pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianCreate";
import ProfessionalGuardianLimits from "../pages/Internal User/Shared Management Pages/Professional Guardian Management/ProfessionalGuardianLimits";
import CarrierList from "../pages/Internal User/Shared Management Pages/Carrier Management/CarrierList";
import CarrierProfile from "../pages/Internal User/Shared Management Pages/Carrier Management/CarrierProfile";
import LawFirmList from "../pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmList";
import CreateLawFirm from "../pages/Internal User/Shared Management Pages/Law Firm Management/CreateLawFirm";
import LawFirmDetail from "../pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmDetails";
import LegalServiceProfessionalForm from "../pages/Internal User/Shared Management Pages/Law Firm Management/AddLawFirmUser";
import EditProfessionalDetailsForm from "../pages/Internal User/Shared Management Pages/Law Firm Management/EditLawFirmUser";
import CreateLocations from "../pages/Internal User/Shared Management Pages/Law Firm Management/CreateLocation";
import LawFirmLocationDetail from "../pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmLocationDetail";
import LawFirmUserLimits from "../pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmUserLimits";
import LawFirmUserList from "../pages/Internal User/Shared Management Pages/Law Firm Management/LawFirmUserList";
import UserList from "../pages/Internal User/Shared Management Pages/Internal User Management/UserList";
import CreateInternalUser from "../pages/Internal User/Shared Management Pages/Internal User Management/NewInternalUser";
import EditInternalUser from "../pages/Internal User/Shared Management Pages/Internal User Management/EditInternalUser";
import PremiumManager from "../pages/Internal User/Shared Management Pages/Other Management Pages/PremiumManager";
import BondNumberTable from "../pages/Internal User/Shared Management Pages/Other Management Pages/BondNumber";
import LawSchoolList from "../pages/Internal User/Shared Management Pages/Other Management Pages/LawSchools";
import StateList from "../pages/Internal User/Shared Management Pages/Other Management Pages/StateList";
import BondTypeList from "../pages/Internal User/Shared Management Pages/Other Management Pages/BondTypes";
import StateDetails from "../pages/Internal User/Shared Management Pages/Other Management Pages/StateDetails";
import ObligeeList from "../pages/Internal User/Shared Management Pages/Other Management Pages/ObligeeList";
import Announcement from "../pages/Internal User/Shared Management Pages/Other Management Pages/Announcement";

// Law firm user pages
import LawFirmUserHome from "../pages/Law Firm User/LawFirmUserHome";
import LawFirmUserAdminHome from "../pages/Law Firm User/LawFirmUserAdminHome";
import LawFirmAccessRequests from "../pages/Law Firm User/LawFirmAccessRequests";
import LawfirmApproveBondsPage from "../pages/Law Firm User/LawFirmApproveBonds";
import LawfirmCancelBondsPage from "../pages/Law Firm User/LawFirmCancelBonds";
import LawfirmEndorseBondsPage from "../pages/Law Firm User/LawFirmEndorseBonds";

// Professional guardian pages
import ProfessionalGuardianHome from "../pages/Professional Guardian User/Home";
import ProfessionalGuardianViewBonds from "../pages/Professional Guardian User/ProfessionalGuardianViewBonds";
import PgContactHome from "../pages/Professional Guardian Contact User/Home";

// Carrier team member pages
import CarrierTeamMemberDashboard from "../pages/CarrierTeamMemberDashboard";

// Paralegal management
import ParalegalList from "../pages/Internal User/Shared Management Pages/Paralegal Management/ParalegalList";
import NewParalegal from "../pages/Internal User/Shared Management Pages/Paralegal Management/NewParalegal";
import ParalegalDetail from "../pages/Internal User/Shared Management Pages/Paralegal Management/ParalegalDetail";

// Enhancement
import ViewEnhancementRequests from "../pages/Internal User/Admin User/EnhancementRequests";

const G = (children) => <AuthGuard>{children}</AuthGuard>;

const authenticatedRoutes = [
  // Bond creation (authenticated)
  <Route key="bond-outsider" path="/bond-creation-outsider" element={G(<VermostOutsiderStartBondRequest />)} />,
  <Route key="bond-outsider-historic" path="/bond-creation-outsider-historic" element={G(<VermostOutsiderStartBondRequestHistoric />)} />,
  <Route key="probate-create" path="/vermost-probate-bond-request" element={G(<VermostProbateBondRequestForm />)} />,
  <Route key="probate-cache" path="/vermost-probate-bond-request-cache/:cache_id" element={G(<VermostProbateBondRequestForm />)} />,
  <Route key="guardianship-create" path="/vermost-guardianship-bond-request" element={G(<VermostGuardianshipBondRequestForm />)} />,
  <Route key="guardianship-cache" path="/vermost-guardianship-bond-request-cache/:cache_id" element={G(<VermostGuardianshipBondRequestForm />)} />,
  <Route key="va-create" path="/vermost-va-bond-request" element={G(<VermostVABondRequestForm />)} />,
  <Route key="va-cache" path="/vermost-va-bond-request-cache/:cache_id" element={G(<VermostVABondRequestForm />)} />,
  <Route key="trustee-create" path="/vermost-trustee-bond-request" element={G(<VermostTrusteeBondRequestForm />)} />,
  <Route key="trustee-cache" path="/vermost-trustee-bond-request-cache/:cache_id" element={G(<VermostTrusteeBondRequestForm />)} />,
  <Route key="blanket-create" path="/vermost-blanket-bond-request" element={G(<VermostBlanketBondRequestForm />)} />,
  <Route key="blanket-cache" path="/vermost-blanket-bond-request-cache/:cache_id" element={G(<VermostBlanketBondRequestForm />)} />,

  // Bond retrieval / update
  <Route key="probate-update" path="/vermost-probate-bond-update/:bond_id" element={G(<VermostProbateBondRetrieveForm />)} />,
  <Route key="guardianship-update" path="/vermost-guardianship-bond-update/:bond_id" element={G(<VermostGuardianshipBondRetrieveForm />)} />,
  <Route key="va-update" path="/vermost-va-bond-update/:bond_id" element={G(<VermostVABondRetrieveForm />)} />,
  <Route key="trustee-update" path="/vermost-trustee-bond-update/:bond_id" element={G(<VermostTrusteeBondRetrieveForm />)} />,
  <Route key="blanket-update" path="/vermost-blanket-bond-update/:bond_id" element={G(<VermostBlanketBondRetrieveForm />)} />,
  <Route key="probate-underwriting" path="/vermost_view_probate_underwriting" element={G(<VermostProbateBondRetrieveForm />)} />,

  // Historic bond creation
  <Route key="probate-historic" path="/vermost-probate-bond-historic" element={G(<ProbateBondCreateHistoric />)} />,
  <Route key="guardianship-historic" path="/vermost-guardianship-bond-historic" element={G(<GuardianshipBondCreateHistoric />)} />,
  <Route key="trustee-historic" path="/vermost-trustee-bond-historic" element={G(<TrusteeBondCreateHistoric />)} />,
  <Route key="blanket-historic" path="/vermost-blanket-bond-historic" element={G(<BlanketBondCreateHistoric />)} />,
  <Route key="va-historic" path="/vermost-va-bond-historic" element={G(<VABondCreateHistoric />)} />,

  // Riders
  <Route key="rider-probate" path="/release-rider-probate/:bond_id" element={G(<ProbateRider />)} />,
  <Route key="rider-guardianship" path="/release-rider-guardianship/:bond_id" element={G(<GuardianshipRider />)} />,
  <Route key="rider-trustee" path="/release-rider-trustee/:bond_id" element={G(<TrusteeRider />)} />,
  <Route key="rider-va" path="/release-rider-va/:bond_id" element={G(<VABondRider />)} />,

  // Bond operations
  <Route key="approve-bonds" path="/vermost_approve_bonds" element={G(<ApproveBondsPage />)} />,
  <Route key="bond-archives" path="/vermost_bond_archives" element={G(<BondArchives />)} />,
  <Route key="approve-team" path="/vermost_approve_bonds_teammember" element={G(<ApproveBondsTeamMemberPage />)} />,
  <Route key="premium-calc" path="/premium_calculator" element={G(<PremiumCalculator />)} />,

  // Internal user home / account
  <Route key="internal-home" path="/internal_user_home" element={G(<SimpleUserHome />)} />,
  <Route key="simple-account" path="/simple_user_account_management" element={G(<SimpleUserAccountManagement />)} />,
  <Route key="simple-data" path="/simple_user_data_management" element={G(<SimpleUserDataManagement />)} />,
  <Route key="simple-system" path="/simple_user_system_management" element={G(<SimpleUserSystemManagement />)} />,

  // Professional guardian
  <Route key="pg-home" path="/professional_guardian_home" element={G(<ProfessionalGuardianHome />)} />,
  <Route key="pg-bonds" path="/professional_guardian_view_bonds/:id" element={G(<ProfessionalGuardianViewBonds />)} />,
  <Route key="pg-list" path="/vermost-professional-guardian-list" element={G(<ProfessionalGuardianList />)} />,
  <Route key="pg-view" path="/view_professional_guardian/:pg_id" element={G(<ProfessionalGuardianView />)} />,
  <Route key="pg-create" path="/create_professional_guardian" element={G(<CreateProfessionalGuardian />)} />,
  <Route key="pg-limits" path="/guardian-limits/:pg_id" element={G(<ProfessionalGuardianLimits />)} />,

  // PG contact
  <Route key="pgc-home" path="/pg_contact_home" element={G(<PgContactHome />)} />,

  // Law firm
  <Route key="lf-home" path="/law_firm_user_home" element={G(<LawFirmUserHome />)} />,
  <Route key="lf-admin-home" path="/law_firm_admin_home" element={G(<LawFirmUserAdminHome />)} />,
  <Route key="lf-access" path="/law-firm/access-requests" element={G(<LawFirmAccessRequests />)} />,
  <Route key="lf-approve" path="/vermost_approve_bonds_lawfirm" element={G(<LawfirmApproveBondsPage />)} />,
  <Route key="lf-cancel" path="/vermost_cancel_bonds_lawfirm" element={G(<LawfirmCancelBondsPage />)} />,
  <Route key="lf-endorse" path="/vermost_endorse_bonds_lawfirm" element={G(<LawfirmEndorseBondsPage />)} />,
  <Route key="lf-list" path="/vermost_lawfirm_list" element={G(<LawFirmList />)} />,
  <Route key="lf-create" path="/add_law_firm" element={G(<CreateLawFirm />)} />,
  <Route key="lf-detail" path="/lawfirmdetails/:id" element={G(<LawFirmDetail />)} />,
  <Route key="lf-add-user" path="/addlawfirmuser/:id" element={G(<LegalServiceProfessionalForm />)} />,
  <Route key="lf-edit-user" path="/editlawfirmuser/:id/:location_id" element={G(<EditProfessionalDetailsForm />)} />,
  <Route key="lf-add-loc" path="/add_location/:id" element={G(<CreateLocations />)} />,
  <Route key="lf-loc-detail" path="/lawfirmlocationdetails/:id" element={G(<LawFirmLocationDetail />)} />,
  <Route key="lf-user-limits" path="/lawfirm-user-limits/:lawfirm_user_id" element={G(<LawFirmUserLimits />)} />,
  <Route key="lf-users" path="/vermost_law_firm_users" element={G(<LawFirmUserList />)} />,

  // Carrier
  <Route key="carrier-list" path="/vermost_carrier_list" element={G(<CarrierList />)} />,
  <Route key="carrier-profile" path="/vermost_carrier_profile/:id" element={G(<CarrierProfile />)} />,
  <Route key="carrier-dash" path="/carrier_team_member_dashboard" element={G(<CarrierTeamMemberDashboard />)} />,

  // Internal user management
  <Route key="int-users" path="/vermost_internal_users" element={G(<UserList />)} />,
  <Route key="int-new" path="/new_internal_user" element={G(<CreateInternalUser />)} />,
  <Route key="int-edit" path="/edit_internal_user/:internal_user_id" element={G(<EditInternalUser />)} />,

  // Reference data
  <Route key="premiums" path="/vermost_premiums_manager" element={G(<PremiumManager />)} />,
  <Route key="bond-numbers" path="/bond_numbers" element={G(<BondNumberTable />)} />,
  <Route key="law-schools" path="/law_schools" element={G(<LawSchoolList />)} />,
  <Route key="states" path="/states" element={G(<StateList />)} />,
  <Route key="state-detail" path="/state-details/:stateId" element={G(<StateDetails />)} />,
  <Route key="bondtypes" path="/bondtypes" element={G(<BondTypeList />)} />,
  <Route key="obligees" path="/obligees" element={G(<ObligeeList />)} />,
  <Route key="announcements" path="/announcements" element={G(<Announcement />)} />,

  // Paralegal
  <Route key="paralegal-list" path="/vermost_paralegals_list" element={G(<ParalegalList />)} />,
  <Route key="paralegal-new" path="/vermost_create_paralegal" element={G(<NewParalegal />)} />,
  <Route key="paralegal-detail" path="/vermost_paralegal_detail/:id" element={G(<ParalegalDetail />)} />,

  // Enhancement
  <Route key="view-enhancements" path="/view-enhancement-requests" element={G(<ViewEnhancementRequests />)} />,
];

export default authenticatedRoutes;
